import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './styles.css.js';

var RadioButton = function RadioButton(_ref) {
  var isToggled = _ref.isToggled,
    handleToggle = _ref.handleToggle,
    text = _ref.text,
    isDisabled = _ref.isDisabled,
    hide = _ref.hide,
    dataTest = _ref.dataTest;
  var handleClick = isDisabled ? null : function () {
    return handleToggle(text);
  };
  var cx = classNames.bind(styles);
  var selected = isToggled && !isDisabled;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('radioButtonContainer', {
      hideRadioContainer: hide,
      checkedRadioContainer: selected
    })
  }, /*#__PURE__*/React.createElement("button", {
    className: cx('radioButton', {
      selectedRadioButton: selected,
      disabledRadioButton: isDisabled
    }),
    onClick: handleClick,
    "data-test": "".concat(dataTest, "-").concat(text),
    disabled: isDisabled,
    type: "button"
  }, /*#__PURE__*/React.createElement("span", null, text)));
};
var func = PropTypes.func,
  bool = PropTypes.bool,
  number = PropTypes.number,
  string = PropTypes.string,
  oneOfType = PropTypes.oneOfType;
RadioButton.propTypes = {
  text: oneOfType([(number)]),
  handleToggle: func.isRequired,
  isToggled: bool,
  isDisabled: bool,
  hide: bool,
  dataTest: string
};
RadioButton.defaultProps = {
  text: '',
  isToggled: false,
  isDisabled: false,
  hide: false,
  dataTest: 'paging-radio-button'
};

export { RadioButton as default };
